import {
  SET_ASSET_PAGE_BACK_LINK,
} from './constants';

export function setAssetPageBackLink(data) {
  return {
    type: SET_ASSET_PAGE_BACK_LINK,
    data,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/analytics-asset/actions.js
 **/